import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { P } from '@/components/ui/typography';
import { formatDate } from 'shared-utils';
import { Notification } from '../../types/Notification';
import { Button } from '@/components/ui';
import { trpc } from '@/trpc/react';
import { View } from 'react-native';

interface TimesheetIssueProps {
  notification: Notification
}

type TimesheetIssueData = {
  query: string;
  response: string;
  resolved: boolean;
  date: string;
}

const mapNotificationToTimesheetIssue = (notification: Notification) => {
  const data = notification.data as TimesheetIssueData;
  return {
    subject: notification.subject,
    data: {
      query: data.query,
      response: data.response,
      resolved: data.resolved,
      date: formatDate(data.date, 'dd/MM/yyyy HH:mm'),
    },
    subject_type_id: notification.subject_type_id,
  }
}

const TimesheetIssue: React.FC<TimesheetIssueProps> = ({ notification }) => {
  const mappedNotification = mapNotificationToTimesheetIssue(notification);
  const { mutate: markAsRead } = trpc.notification.markAsRead.useMutation();

  const handleMarkAsRead = () => {
    markAsRead(notification.id);
  };

  return (
    <Card className="mt-4">
      <CardHeader>
        <CardTitle>{mappedNotification.subject}</CardTitle>
        <CardDescription>
          <P className="font-bold">Your timesheet issue query has been updated</P>
        </CardDescription>
      </CardHeader>
      <CardContent>
        <CardDescription>
          <P className="font-bold">Date:</P>
          <P>{mappedNotification.data.date}</P>
        </CardDescription>
        <CardDescription className="mt-2">
          <P className="font-bold">Query:</P>
          <P>{mappedNotification.data.query}</P>
        </CardDescription>
        <CardDescription className="mt-2">
          <P className="font-bold">Response:</P>
          <P>{mappedNotification.data.response}</P>
        </CardDescription>
        <CardDescription className="mt-2">
          <P className="font-bold">Status:</P>
          <P>{mappedNotification.data.resolved ? 'Resolved' : 'Awaiting response'}</P>
        </CardDescription>
        <View className="mt-4">
          <Button onPress={handleMarkAsRead} variant="crew">
            Mark as read
          </Button>
        </View>
      </CardContent>
    </Card>
  );
};

export default TimesheetIssue;